import { connect } from 'react-redux';
import { getDateFormat } from '../selectors';

export default (propName = 'dateFormat') => connect(
  (state, props) => ({
    [propName]: props[propName] || getDateFormat(state),
  })
);
